export const productionDepartments = {
	DESIGNER: { name: "Designer", key: "DESIGNER" },
};
